export default "__VITE_ASSET__BerZO6Ki__"